<app-internal-page>
    <div *ngIf="!error" class="clinic-content" content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.xs="15px">
        <span class="mat-title">Em qual unidade deseja realizar o atendimento?</span>
        
        <ng-container *ngFor="let clinic of clinics; let i = index">
            <app-selectable-card [selected]="isSelected(clinic.id)" (click)="clinicSelectChanged(i)">
                <app-icon-circle card-icon faIcon="location-dot"></app-icon-circle>
                <span card-description>
                    {{clinic.addressFormated || clinic.name}}
                </span>
            </app-selectable-card>
        </ng-container>

    </div>
</app-internal-page>
